<!-- <button mat-menu-item>
    <mat-icon>account_box</mat-icon>
    <span>Profile Details</span>
</button> -->
<!-- <button mat-menu-item (click)="onSwitch()">
    <mat-icon>swap_horiz</mat-icon>
    <span>Switch Account</span>
</button> -->
<button mat-menu-item (click)="onChangePWD()">
    <mat-icon>settings</mat-icon>
    <span>Change Password</span>
</button>
<button mat-menu-item (click)="onLogout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>Sign Out</span>
</button>